import { useQuery } from '@tanstack/react-query'
import { searchApi } from '../api/search'

export const useFTSSearch = (q: string, page = 1, pageSize = 20) =>
  useQuery({
    queryKey: ['search', 'fts', q, page, pageSize],
    queryFn: () => searchApi.fts(q, page, pageSize).then((r) => r.data),
    enabled: q.trim().length > 0,
    staleTime: 30_000,
  })

export const useAISearch = (q: string, enabled: boolean) =>
  useQuery({
    queryKey: ['search', 'ai', q],
    queryFn: () => searchApi.ai(q).then((r) => r.data),
    enabled: enabled && q.trim().length > 0,
    staleTime: 60_000,
  })

export const useAIKeyStatus = () =>
  useQuery({
    queryKey: ['search', 'ai-key'],
    queryFn: () => searchApi.getAIKeyStatus().then((r) => r.data),
  })
